import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getMapKey',
})
export class GetMapKeyPipe implements PipeTransform {
  transform(map: Map<any, any>, value: any): any {
    return ([...map.entries()]?.find(([_k, v]) => v === value) ?? [])[0];
  }
}
